module.exports = __webpack_public_path__ + "static/media/bell.ebfc5f48.png";